{
  "Thank you for filling in the form.": "Danke, dass Sie das Formular ausgefüllt haben.",
  "There was an error in your submission, please try again in a few seconds. If the issue persists, please contact us.": "Bei Ihrer Eingabe ist ein Fehler aufgetreten, bitte versuchen Sie es in ein paar Sekunden erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte."
}
